import {debounce} from 'lodash';
import {Store} from 'redux';

import {startBugsnagSession} from '../../../srcCommon/services/bugsnag/bugsnag';
import {AppState} from '../../store/appState';
import {makeGetAppPath} from '../../store/panels/app/appPanelSelectors';
import {AppPanelId} from '../../store/panels/panelStateBase';

export function setupBugsnagSessions(store: Store<AppState>, panelId: AppPanelId) {
  const getAppPath = makeGetAppPath();
  let previousPath: string | undefined;

  // Debounce location changes so fast conversation switching is not hindered by Bugsnag session requests.
  const onLocationChangeDebounced = debounce((path: string) => {
    if (path === previousPath) {
      return;
    }

    previousPath = path;
    startBugsnagSession();
  }, 0);

  store.subscribe(() => {
    const state = store.getState();
    const path = getAppPath(state, {panelId});
    onLocationChangeDebounced(path);
  });
}
